<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Add Clients</h3>
      </v-col>
      <v-col cols="12" md="6">
        <v-form ref="form">
          <v-text-field outlined :rules="notEmpty" v-model="userForm.name" label="Enter Client Name"/>
          <v-text-field outlined :rules="notEmpty" v-model="userForm.email" label="Enter Client Email"/>
          <v-text-field outlined :rules="notEmpty" v-model="userForm.phone" label="Enter Client Phone"/>
          <v-text-field outlined :rules="notEmpty" v-model="userForm.idnumber" label="Enter ID number"/>
        </v-form>
        <v-btn class="primary" @click="registerClient">Create</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <table-widget title="My Clients" :headers="headers" :table-row-data="clients"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";
import TableWidget from "@/components/widgets/tables/TableWidget";

export default {
  name: "AddClients",
  components: {TableWidget},
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {text: 'Email', value: 'email'},
        {text: 'Phone', value: 'phone'},
        {text: 'Actions', value: 'action'}
      ],
      clients: [],
      userForm: new Form({
        name: "",
        email: "",
        phone: "",
        idnumber: "",
        type: "client",

      }),
      notEmpty: [
        v => !!v || 'Field is required',
      ],
    }
  },
  methods: {
    registerClient() {
      if (this.$refs.form.validate()) {
        postRequest('registerClient', this.userForm).then(res => {
          swal.fire('Success', 'Added Client', 'success')
          this.userForm.reset()
        }).catch(e => {
          swal.fire('Error', 'Error Adding Client', 'error')
        })
      }
    },
    getClients() {
      getRequest('getClients').then(({data}) => {
        this.clients = data;
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
    this.getClients()
  }
}
</script>

<style scoped>

</style>